
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cmscoreapp",
      function () {
        return require("private-next-pages/cmscoreapp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cmscoreapp"])
      });
    }
  